import {FullPageSpinner} from "../../components/loading/Spinner";
import {useEffect} from "react";
import {useParams} from "react-router";
import {Navigate} from "react-router-dom";
import {createClasslinkUri, createCleverUri, isUnsupportedProvider} from "./provider-login";

export const ProviderPreAuthPage = () => {
  const params = useParams();
  const provider = params.provider || "";

  useEffect(() => {
    if (provider === "clever") {
      const u = createCleverUri();
      window.location.assign(u)
    }
    if (provider === "classlink") {
      const u = createClasslinkUri();
      window.location.assign(u)
    }
  }, []);

  if (isUnsupportedProvider(provider)) {
    return <Navigate to="/error"/>
  }
  return <FullPageSpinner/>;
};
